import React, { useEffect, useState } from 'react';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInputValidate.jsx";
import Table from "components/Table/Table.jsx";
import Close from "@material-ui/icons/Close";
import Add from "@material-ui/icons/Add";
import Button from "components/CustomButtons/Button.jsx";
import { clone } from "shared/utility";

const dict = {
    R: 'Read only',
    F: 'Full access (Update, Delete)',
    E: 'Edit (Update only)'
}

const PropertiesSharing = (props) => {
    const [users, setUsers] = useState([]); // already shared
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (props.dataObj.id) {
            
            props.getPropertyShares(props.dataObj.id);
        } else {

        }
        props.getPropertyUsernames();
    }, []);

    useEffect(() => {
        setUsers(clone(props.sharesForAdd));
    }, [props.sharesForAdd])

    useEffect(() => {
        if (props.action !== 'Add') {
            setUsers([ ...props.propertyShares]);
        }
    }, [props.propertyShares])

    const usersArr = users.sort((a, b) => (a.name > b.name) ? 1 : -1).map((u,i) => {
            return [
                u.name,
                dict[u.access],
                <div className="red-text hoverable"
                    onClick={() => {
                        if (props.action !== 'Add') {
                            props.deletePropertyShare(u.id);
                            setTimeout(() => {
                                props.getPropertyShares(props.dataObj.id);
                            }, 1000);
                        } else {
                            removeShare(i);
                        }
                    }}
                ><Close /></div>
            ]
        });

    

    const addShare = (obj) => {
        const newShareArr = clone(props.sharesForAdd);
        props.setSharesForAdd([ ...newShareArr, obj]);
    }

    const removeShare = (j) => {
        const newShareArr = clone(props.sharesForAdd);
        props.setSharesForAdd(newShareArr.filter((f,i) => {
            if (i !== j) return true;
        }))
    }

    return (
    <div className={props.action === "View" ? "no-click lightgray-bg enclosure" : "enclosure"}>
        <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
                <h4 className="bold">Users this property is shared with</h4>
                <div className="illi-table">
                    <Table
                        tableHeaderColor="primary"
                        tableHead={[<strong>Name</strong>,<strong>Access</strong>,<strong>Remove</strong>]}
                        tableData={usersArr}
                    />
                    {usersArr.length === 0 && <div className="text-center" 
                        style={{marginTop:20}}><em>None</em></div>}
                </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                    label="Search Users"
                    value={search}
                    onChange={(e) => { setSearch(e.target.value) }}
                />
                <div style={{padding:20}}>
                    {props.propertyUsernames ? 
                        props.propertyUsernames.filter(f => {
                            let alreadyShared = false;
                            users.forEach(u => {
                                
                                if (u.user_id === f.id) {
                                    alreadyShared = true;
                                }
                            })
                            // Superusers / Testing Users filtered
                            if (f.id === 1 || f.id === 2) return false;
                            if (alreadyShared) return false;
                            if (!search) return true;
                            const lowered = f.name.toLowerCase();
                            const s = search.toLowerCase();
                            if (lowered.indexOf(s) === 0) {
                                return true;
                            }
                            return false;
                        })
                        .sort((a, b) => (a.name > b.name) ? 1 : -1)
                        .map((m,i) => {
                            return <div key={`cu-${i}`} className="tiny-box">
                                <Button 
                                    color="primary"
                                    size="sm"
                                    style={{marginRight:20}} 
                                    onClick={() => { 
                                        const newShare = {
                                            user_id: m.id,
                                            access: 'F'
                                        }
                                        if (props.action !== 'Add') {
                                            newShare.property_id = props.dataObj.id;
                                            props.createPropertyShare(newShare);
                                            setTimeout(() => {
                                                props.getPropertyShares(props.dataObj.id);
                                            }, 1000);
                                        } else {
                                            newShare.name = m.name;
                                            addShare(newShare)
                                        }
                                    }}><Add /> Full</Button> 
                                <Button 
                                color="primary"
                                size="sm"
                                style={{marginRight:20}} 
                                onClick={() => { 
                                    const newShare = {
                                        user_id: m.id,
                                        access: 'E'
                                    }
                                    if (props.action !== 'Add') {
                                        newShare.property_id = props.dataObj.id;
                                        props.createPropertyShare(newShare);
                                        setTimeout(() => {
                                            props.getPropertyShares(props.dataObj.id);
                                        }, 1000);
                                    } else {
                                        newShare.name = m.name;
                                        addShare(newShare)
                                    }
                                }}><Add /> Edit</Button> 
                                <Button 
                                color="primary"
                                size="sm"
                                style={{marginRight:20}} 
                                onClick={() => { 
                                    const newShare = {
                                        user_id: m.id,
                                        access: 'R'
                                    }
                                    if (props.action !== 'Add') {
                                        newShare.property_id = props.dataObj.id;
                                        props.createPropertyShare(newShare);
                                        setTimeout(() => {
                                            props.getPropertyShares(props.dataObj.id);
                                        }, 1000);
                                    } else {
                                        newShare.name = m.name;
                                        addShare(newShare)
                                    }
                                }}><Add /> Read</Button> 
                                <span>{m.name} </span>
                            </div>
                        })
                    : 
                        null}
                </div>
            </GridItem>
        </GridContainer>
    </div>
    )
}

export default PropertiesSharing;